import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Button,
  SwipeableDrawer,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle";
import { toast } from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Notification from "../../components/Notification";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import sample_candidates from "../../images/files/sample_candidates.xlsx";
import "../../css/candidate-profile.css";
import * as XLSX from "xlsx";
import { useHistory } from "react-router-dom";
import { saveAs } from "file-saver";

export default function CheckedCandidateList(props) {
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const candidate_search = window.location.search;
  const positions = [toast.POSITION.TOP_RIGHT];
  const [file, setFile] = useState(null);
  const [activeModal, setActiveModal] = useState(null);

  const handleOpenModal = (type) => {
    setActiveModal(type);
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [secureCandiData, setSecureCandiData] = useState([]);

  var [notificationsPosition] = useState(2);
  var [errorToastId, setErrorToastId] = useState(null);
  const filterRef = useRef(null);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [modalPendingOpen, setModalPendingOpen] = React.useState(false);

  const handleCandidateUploadClose = () => {
    setModalPendingOpen(false);
  };

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const validationSchema = Yup.object().shape({
    groupName: Yup.string().required("Group Name is Required"),
    candidates: Yup.array()
      .of(
        Yup.object().shape({
          candidateName: Yup.string().required("Missing Name"),
          candidateEmail: Yup.string().required("Missing Email"),
          countryCode: Yup.string().required("Missing Country Code"),
          candidateMobile: Yup.string().required("Missing Mobile"),
          requirementName: Yup.string().required("Missing Requirement Name"),
        }),
      )
      .min(1, "At least one candidate info is required"),
  });

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    fetchData({ page });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = async ({ page }) => {
    if (!candidate_search) {
      return;
    }

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}duplicateCheck/vendor/myCandidateList`,
      params: {
        page: page + 1,
        groupId: new URLSearchParams(candidate_search).get("groupId"),
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((response) => {
        if (response.data.status === true) {
          setLoader(false);
          setSecureCandiData(response.data.data);
          setCount(response.data.count);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  async function handleAddBulkCandidates(values) {
    try {
      setLoader(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}duplicateCheck/bulkAdd`,
        data: {
          groupName: values.groupName,
          excelName: file.name,
          data: values.candidates,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        handleCandidateUploadClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  var table_data = {};

  var table_columns = [];

  table_columns = [
    {
      name: "S.No",
    },
    {
      name: "Email",
    },
    {
      name: "Mobile No",
    },
    {
      name: "Last Updated Date",
    },
  ];

  table_data = secureCandiData.map((item, index) => {
    return [
      <>{page !== 0 ? 10 * page - 10 + index + 1 : index + 1}</>,
      <div className="hashed-file-name">{item.candidateEmail}</div>,
      <div className="hashed-file-name">
        {item.countryCode + item.candidateMobile}
      </div>,
      moment(item.createdAt).format("DD-MM-YYYY"),
    ];
  });

  const HeaderElements = () => (
    <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
      <div className="card-right">
        <button
          type="button"
          onClick={() => handleOpenModal("download-excel")}
          className="download-btn"
        >
          Download
        </button>
      </div>
      <p>Total : {count}</p>
    </div>
  );

  const [state, setState] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleUploadExcelFile = (e) => {
    if (!e.target.files) {
      return;
    }
    const dataFile = e.target.files[0];
    setFile(dataFile);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target?.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const records = XLSX.utils.sheet_to_json(sheet);

      const candidateCollection = records?.map((item) => ({
        candidateName: item["Name"],
        candidateEmail: item["Email"],
        countryCode: item["Country Code"],
        candidateMobile: item["Mobile"],
        requirementName: item["Requirement Name"],
      }));

      setValue("candidates", candidateCollection);
      // setEmpPayslipData(records);
    };

    // reader.onload = async function (event) {
    //   const binaryStr = event.target?.result;
    //   if (!binaryStr) return;

    //   // Read the workbook
    //   const workbook = XLSX.read(binaryStr, { type: "binary" });

    //   // Get the first sheet
    //   const candidatesData = workbook.SheetNames[0];
    //   const candidatesDataWorkSheet = workbook.Sheets[candidatesData];

    //   const listSheetInfo = XLSX.utils.sheet_to_json(candidatesDataWorkSheet, {
    //     header: 1,
    //   });

    //   console.info(listSheetInfo[0].slice(1), "-=-=List Data Collected-=-=");
    // };

    reader.readAsArrayBuffer(dataFile);
  };

  const formatSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const generateExcelData = (data, fileName) => {
    if (!data || data.length === 0) {
      handleNotificationCall("error", "No data available to download");
      return;
    }

    try {
      setLoader(true);

      const formattedData = data.map((item, index) => ({
        "S. No": index + 1,
        Name: item.candidateName,
        Email: item.candidateEmail,
        Mobile: item.candidateMobile,
        "Country Code": item.countryCode,
        "Creation Date": moment(item.createdAt).format("DD-MM-YYYY"),
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Break Report");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const dataBlob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(dataBlob, `${fileName}.xlsx`);
      handleNotificationCall("success", "Excel downloaded successfully");
      handleCloseModal();
    } catch (error) {
      console.error("Excel download failed:", error);
      handleCloseModal();
    } finally {
      setLoader(false);
    }
  };

  const handleDownloadRecord = async (pageNumber = 1) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}duplicateCheck/vendor/excelDownload/candidateList`,
        {
          params: {
            page: pageNumber,
            groupId: new URLSearchParams(candidate_search).get("groupId"),
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      if (response.data.status) {
        const responseData = response.data.data;
        generateExcelData(
          responseData,
          `Secure_Profile_Report_-Part-${pageNumber}`,
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Secured Candidates Profile" />
        </Grid>
      </Grid>

      {/* <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>
          <TextField
            name="fromDate"
            label="From"
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            type="date"
            defaultValue={fromDate}
            onChange={handleFromDateChange}
          />

          <TextField
            name="toDate"
            label="To"
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            type="date"
            defaultValue={toDate}
            onChange={handleToDateChange}
          />

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              type="submit"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => resetForm()}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form> */}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title={""}
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              print: false,
              download: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={table_columns}
            data={table_data}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleCandidateUploadClose}
        open={modalPendingOpen}
        width="sm"
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Upload .XLSX File
            </Typography>
            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleCandidateUploadClose}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(handleAddBulkCandidates)}>
            <Grid item xs={12}>
              <InputLabel shrink htmlFor="groupName">
                Group Name
              </InputLabel>
              <FormControl className={classes.margin}>
                <TextField
                  InputProps={{ disableUnderline: true }}
                  classes={{ root: classes.customTextField }}
                  size="small"
                  placeholder="Group Name"
                  name="groupName"
                  {...register("groupName")}
                  error={errors.groupName ? true : false}
                />

                <Typography variant="inherit" color="error">
                  {errors.groupName?.message}
                </Typography>
              </FormControl>
            </Grid>
            <Grid className={classes.filterGap + " " + classes.center}>
              <div className="upload-container">
                <div className="upload-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="upload-icon"
                    viewBox="0 0 32 32"
                  >
                    <title>file_type_excel2</title>
                    <path
                      d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z"
                      style={{ fill: "#20744a", fillRule: "evenodd" }}
                    />
                    <rect
                      x="22.487"
                      y="7.439"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="10.94"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="14.441"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="17.942"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="21.443"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <polygon
                      points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673"
                      style={{ fill: "#ffffff", fillRule: "evenodd" }}
                    />
                  </svg>

                  <span className="upload-text">
                    Click to upload your files here
                  </span>
                  <span className="upload-subtext">(only .XLSX Format)</span>
                </div>

                <input
                  type="file"
                  name="upload-file"
                  accept=".xlsx"
                  className="upload-input"
                  onChange={handleUploadExcelFile}
                />
              </div>
            </Grid>
            {file && (
              <Grid>
                <div className="file-card">
                  <div className="file-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M4 4h16v16H4z" />
                    </svg>
                  </div>
                  <div className="file-info">
                    <div className="file-name">{file.name}</div>
                    <div className="file-size">{formatSize(file.size)}</div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setFile(null)}
                    className="file-action"
                  >
                    Remove
                  </button>
                </div>
              </Grid>
            )}
            <Grid className={classes.center}>
              <Grid style={{ padding: "10px 0px" }}>
                Sample excel format to upload your candidate details (Only then
                Vendor / Freelancer can check duplicate)
                <a
                  href={sample_candidates}
                  style={{ marginLeft: "4px" }}
                  className={classes.aLink}
                  download
                >
                  download
                </a>
              </Grid>
            </Grid>

            <Grid className={classes.center + " " + classes.button}>
              <Typography variant="inherit" className={classes.lineBreak}>
                {file?.name}
              </Typography>
            </Grid>
            <div className={classes.sendWhatsapp}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="submit"
              >
                Yes, Send
              </Button>

              <Button
                variant="contained"
                size="small"
                color="secondary"
                type="button"
                onClick={handleCandidateUploadClose}
              >
                No, Cancel
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        onClose={handleCloseModal}
        aria-labelledby="dialog-title"
        open={activeModal === "download-excel"}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Download Excel
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleCloseModal}
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <div className="download-card">
            <div className="card-header">
              <div className="card-left">
                <div className="icon-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="800px"
                    height="800px"
                    viewBox="0 0 32 32"
                    className="excel-icon"
                  >
                    <title>file_type_excel2</title>
                    <path
                      d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z"
                      style={{ fill: "#20744a", fillRule: "evenodd" }}
                    />
                    <rect
                      x="22.487"
                      y="7.439"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="10.94"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="14.441"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="17.942"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="21.443"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <polygon
                      points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673"
                      style={{ fill: "#ffffff", fillRule: "evenodd" }}
                    />
                  </svg>
                </div>
                <div className="card-text">
                  <div className="card-title">
                    Secured Candidate Profile Records
                  </div>
                </div>
              </div>
              <div className="card-right">
                <button
                  type="button"
                  onClick={() => handleDownloadRecord(1)}
                  className="download-btn"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <SwipeableDrawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        classes={{ paper: classes.drawer }}
      >
        {/* {list("right")} */}
      </SwipeableDrawer>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
